/*
  Строка вкладки «Подсудность домов»: дом, помещения, участок, протокол и что делать.

  🔴 Решение владельца 02.11.2026 (вариант А): откуда взят участок, в строке НЕ
  показывается - ни «найден по ГАС «Правосудие»», ни «ваш справочник». Состояние
  «участок уточняется» - не источник, а то, что требует действия, оно показывается.

  Что предлагает строка, решает состояние дома с сервера (`state`), а не экран:
  - участок есть, протокола нет - «Внести протокол» и, если участок не свой, «Другой
    участок» (мастер привязки к вашему участку);
  - участок есть, протокол есть - скан и «Изменить»;
  - участок уточняется - «Указать участок»; ещё не проверен - «Указать участок сами»;
  - дом от квартиры не отделить («ул. Ленина, 3-14») - кнопок нет, дом заводится
    вручную, как в справочнике.

  Действия держит `CourtHousesTab`; здесь ничего не грузится.
*/

import { Lock } from './AccessContext.jsx'
import { basisText } from './CourtBuildingBasis.jsx'
import { Tag } from './Common.jsx'
import ProtocolScanLink from './ProtocolScanLink.jsx'

export default function CourtHouseRow({ house, onProtocol, onEdit, onBind }) {
  return (
    <tr>
      <td>
        <HouseAddress house={house} />
      </td>
      <td className="table__num" data-label="Помещений">
        {house.premises_count}
      </td>
      <td className="table__block" data-label="Участок">
        <CourtCell house={house} />
      </td>
      <td className="table__block" data-label="Протокол собрания">
        <ProtocolCell house={house} />
      </td>
      <td>
        <Actions house={house} onProtocol={onProtocol} onEdit={onEdit} onBind={onBind} />
      </td>
    </tr>
  )
}

function HouseAddress({ house }) {
  return (
    <>
      {house.full_address || house.address}
      {house.full_address && house.full_address !== house.address ? (
        <div className="muted">в выгрузке: {house.address}</div>
      ) : null}
      {house.needs_full_address ? (
        <div>
          <Tag kind="warn">нужен полный адрес</Tag>
        </div>
      ) : null}
    </>
  )
}

function CourtCell({ house }) {
  if (house.court) {
    return (
      <>
        № {house.court.number}
        {house.court.note ? <div className="muted">{house.court.note}</div> : null}
      </>
    )
  }
  if (house.state === 'disputed') {
    return (
      <>
        <Tag kind="warn">участок уточняется</Tag>
        <div className="muted">{house.problem}</div>
      </>
    )
  }
  return <span className="muted">участок ещё ищется</span>
}

function ProtocolCell({ house }) {
  if (house.has_management_basis) {
    return (
      <>
        {basisText(house)}
        <ProtocolScanLink sectionId={null} building={{ ...house, id: house.building_id }} />
      </>
    )
  }
  if (house.state === 'unchecked') return <span className="muted">-</span>
  return (
    <>
      <Tag kind="burn">нет протокола</Tag>
      <div className="muted">заявления не собираются</div>
    </>
  )
}

function Actions({ house, onProtocol, onEdit, onBind }) {
  if (!house.bindable) {
    return (
      <span className="muted">
        Дом и квартиру здесь не различить - заведите дом вручную на вкладке «Участки мировых
        судей».
      </span>
    )
  }
  const quiet = 'button button--quiet'
  const withCourt = Boolean(house.court)
  return (
    <Lock>
      {withCourt ? (
        <>
          <button
            className={house.has_management_basis ? quiet : 'button'}
            type="button"
            onClick={() => onProtocol(house)}
          >
            {protocolTitle(house)}
          </button>{' '}
        </>
      ) : null}
      {house.building_id && (house.has_management_basis || house.needs_full_address) ? (
        <>
          <button className={quiet} type="button" onClick={() => onEdit(house)}>
            Изменить
          </button>{' '}
        </>
      ) : null}
      {/* Дом своего участка меняет участок на вкладке «Участки мировых судей»:
          привязка второй раз получила бы отказ «дом уже привязан». */}
      {house.section_id ? null : (
        <button
          className={withCourt || house.state === 'unchecked' ? quiet : 'button'}
          type="button"
          onClick={() => onBind(house)}
        >
          {bindTitle(house)}
        </button>
      )}
    </Lock>
  )
}

function protocolTitle(house) {
  if (!house.has_management_basis) return 'Внести протокол'
  return house.protocol_scan ? 'Заменить скан' : 'Приложить скан'
}

function bindTitle(house) {
  if (house.court) return 'Другой участок'
  return house.state === 'unchecked' ? 'Указать участок сами' : 'Указать участок'
}
